import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/pazienti/PazientiList.vue'),
		meta: {
			title: 'patients',
			acl: 'section.pazienti'
		}
	},
	
];

export default routes;